// extracted by mini-css-extract-plugin
module.exports = {"detail":"lift-detail_detail_2KyjW","listWrap":"lift-detail_listWrap_2D_yJ"};